export var FORM_DEFAULT_ERROR = 'Что-то пошло не так. Попробуйте снова или зайдите позже';